import type {
  DestinationCenterPoint,
  IDestination,
  ILocalizedDestinationMap,
} from '@/shared/api/types/destination-types'
import { toNumberOrNull } from '@/shared/api/utils/to-number-or-null'

export interface DestinationDTO {
  id: string
  countryId: string
  provinceId: string
  slug: string
  destinationType?: string | null
  centerLat?: string | number | null
  centerLng?: string | number | null
  areaBoundary?: IDestination['areaBoundary']
  banner?: string | null
  thumbnail?: string | null
  isActive: boolean
  localizedData?: ILocalizedDestinationMap | null
  createdAt: string
  updatedAt: string
}

export function mapDestinationDto(dto: DestinationDTO): IDestination {
  const normalizedCenterPoint = ((): DestinationCenterPoint | null => {
    const lat = toNumberOrNull(dto.centerLat)
    const lng = toNumberOrNull(dto.centerLng)
    if (lat === null || lng === null) {
      return null
    }
    return [lng, lat]
  })()

  return {
    id: dto.id,
    countryId: dto.countryId,
    provinceId: dto.provinceId,
    slug: dto.slug,
    destinationType: dto.destinationType ?? null,
    centerPoint: normalizedCenterPoint,
    areaBoundary: Array.isArray(dto.areaBoundary) ? dto.areaBoundary : null,
    banner: dto.banner ?? null,
    thumbnail: dto.thumbnail ?? null,
    isActive: dto.isActive,
    localizedData: dto.localizedData ?? null,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  }
}
